import React from 'react';
import ShareIcon from 'components/pure/utils/icon/ShareIcon';
import './TrendCallHistory.styl';
import {Link} from 'react-router';
import IconButton from 'material-ui/IconButton';
import InboxCallSharingDialogContainer from 'components/inbox/mail-table/toggles/InboxCallSharingDialogContainer';

import ToastActions from '@store/toast/ToastActions';
import Loading from 'components/pure/utils/Loading';

export default class TrendCallHistory extends React.Component {
  constructor(props) {
    super(props);
    this.onShare = this.onShare.bind(this);
    this.state = {
      sharingDialogToggled: false,
      callToShare: undefined,
    };
  }
  onRequestShare(e, i) {
    e.stopPropagation();
    this.setState({sharingDialogToggled: true, callToShare: i});
  }
  onShare() {
    ToastActions.addToast({
      message: `Successfully shared ${this.state.callToShare.callLineOne}.`,
    });
    this.setState({sharingDialogToggled: false, callToShare: undefined});
  }

  render() {
    const {trendHistory, trendHistoryLoading, item} = this.props;

    const ruleItems = trendHistory ? trendHistory.ruleItems : null;
    const moreItems = trendHistory ? trendHistory.moreItems : false;

    const itemId = item ? item.id : 0;

    return (
      <div className="trend-call-history-wrapper">
        <div>
          <h4>Calls Matching Trend</h4>
          {moreItems && (
            <p className="sub-title">More than 100 calls matched, showing the most recent 100</p>
          )}
        </div>
        <div>
          {trendHistoryLoading && (
            <div className="loading-wrapper">
              <Loading />
            </div>
          )}
          {ruleItems &&
            ruleItems.map((i, idx) => (
              <Link
                key={idx}
                className="row"
                to={{
                  pathname: `/inbox/items/${itemId}/calls/${i.fileUploadId}`,
                  query: {
                    folderId: item && item.folderId,
                  },
                  state: {
                    hideActionButtons: true,
                  },
                }}>
                <div className="matched-rule-column">{i.description}</div>
                <div className="call-title-column">
                  <span className="call-title">{i.callLineOne}</span>
                  <span className="caller">{i.caller.getFullName() + ', '}</span>
                  <span className="date">{i.matchDate.format('M/D/YYYY')}</span>
                </div>
                <div className="actions-column">
                  <IconButton onClick={e => this.onRequestShare(e, i)}>
                    <ShareIcon />
                  </IconButton>
                </div>
              </Link>
            ))}
        </div>
        {this.state.sharingDialogToggled && (
          <InboxCallSharingDialogContainer
            open={true}
            fileUploadId={this.state.callToShare.fileUploadId}
            onRequestClose={() =>
              this.setState({
                sharingDialogToggled: false,
                callToShare: undefined,
              })
            }
            onShare={this.onShare}
          />
        )}
      </div>
    );
  }
}
